export default __webpack_public_path__ + "static/media/ONIC_Esports_cloudxier1.0eac4ba1.png";